// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"b5-z","colorTextValue":"c5-z","swatches":"d5-z","collapseLink":"e5-z","isCollapsed":"f5-z","dropdown":"g5-z","disabled":"h5-z"};